module.exports = __webpack_public_path__ + "img/icn_back.9534d9d6.svg";